﻿/// <reference path="fill-survey/fill-surveys-routing.module.ts" />
/// <reference path="fill-survey/fill-surveys.module.ts" />

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CanActivateGuard } from '../core/guards/can-activate.guard';
import { RoleEnum } from '../core/models/role';
import { AllSurveyListComponent } from './all-survey-list/all-survey-list.component';
import { MySurveyListComponent } from './my-survey-list/my-survey-list.component';
import { PublicSurveyListComponent } from './public-survey-list/public-survey-list.component';

import { SurveysService } from './surveys.service';

const routes: Routes = [
    {
        path: 'public-surveys', component: PublicSurveyListComponent
    },
    {
        path: 'my-surveys', component: MySurveyListComponent
    },
    {
        path: 'all-surveys', component: AllSurveyListComponent,
        data: { roles: [RoleEnum.Anketar] },
        canActivate: [CanActivateGuard]
    },
    {
        path: 'fill-survey', loadChildren: 'app/survey/fill-survey/fill-surveys.module#FillSurveysModule'
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
    providers: [SurveysService]
})
export class SurveysRoutingModule { }